import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "定尺",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfTeisyaku"
    label={label}
    size="small"
    inputProps={{ maxLength: 3 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;